<template>
<div>
  <b-card>    
    <grid-filters grid-data="theGrid" :fields="gridFilters" ></grid-filters>
    <Grid ref="theGrid" name="distSalesGrid" v-bind:url="url" v-bind:preload="preload" v-bind:columns="columns" :pageable='true' :filterable='true' :sortable='true' v-bind:schemaModelFields="schemaModelFields"></Grid>
  </b-card>
</div>
</template>

<script>
import Grid from '@/components/Grid.vue'
import router from '@/router'
import lists from '@/components/States.js'

export default {
  name: 'distSalesGrid',
  components: {
    Grid
  },
  data() {
    return {
      recalculating: false,
      filters: {
        dsr: null,
        dsr_id: null
      },
      gridFilters: [{
        field:'dealer_id',
        modal:'dealers-modal',
        foreign: 'id',
        placeholder: 'Distribuidor'
      }, {
        field:'dsr_id',
        modal:'dsr-modal',
        foreign: 'id',
        placeholder: 'DSR'
      }, {
        field:'zone',
        modal:'zones-modal',
        foreign: 'zone',
        placeholder: 'Zona'
      }, {
        field:'prodaggreg_id',
        modal:'prodaggreg-modal',
        foreign: 'id',
        placeholder: 'Prodaggreg'
      }],
      schemaModelFields: {
        'created_at': {
          type: 'date'
        },
        'date': {
          type: 'date'
        },
        'ym': {
          type: 'number'
        },
        'dsr_id': {
          type: 'number'
        },
        'value': {
          type: 'number'
        },
        'quantity': {
          type: 'number'
        },
        'product_id': {
          type: 'number'
        },
        'prodaggreg_id': {
          type: 'number'
        }
      },
      preload: [{
        api: 'dsr/lst/dsr',
        field: 'dsr_id'
      }, {
        api: 'dealers/lst',
        field: 'dealer_id'
      }],
      url: 'sales/distsales',
      columns: [{
        field: 'date',
        title: 'Data',
        format: '{0:dd/MM/yyyy}',
        type: 'date',
        width: '160px',
        filterable: {
          // ui: "datetimepicker"
          ui: function(element) {
            element.kendoDateTimePicker({
              format: 'dd/MM/yyyy'
            })
          }
        }
      },
      {
        field: 'ym',
        title: 'Ano / Mês',
        width: '120px'
      },
      {
        field: 'dealer_id',
        title: 'Distribuidor',
        width: '220px'
      },
      {
        field: 'dsr_id',
        title: 'DSR',
        width: '220px'
      },
      {
        field: 'zone',
        title: 'Zona',
        width: '120px'
      },
      {
        field: 'codle',
        title: 'CODLE',
        width: '160px'
      },
      {
        field: 'nif',
        title: 'NIF',
        width: '120px'
      },
      {
        field: 'le',
        title: 'LE',
        width: '120px'
      },
      {
        field: 'operator_id',
        title: 'ID Operador',
        width: '120px'
      },
      {
        field: 'value',
        title: 'Valor',
        width: '120px'
      },
      {
        field: 'quantity',
        title: 'Quantidade',
        width: '120px'
      },
      {
        field: 'sku',
        title: 'SKU',
        width: '120px'
      },
      {
        field: 'product_id',
        title: 'ID Produto',
        width: '120px'
      },
      {
        field: 'prodaggreg_id',
        title: 'ID Prodaggreg',
        width: '120px'
      },
      {
        field: 'dsr_code',
        title: 'Codigo DSR',
        width: '120px'
      },
      {
        field: 'original_quantity',
        title: 'Quantidade Original',
        width: '120px'
      },
      {
        field: 'created_at',
        title: 'Criado em',
        format: '{0:dd/MM/yyyy HH:mm}',
        type: 'date',
        width: '180px',
        filterable: {
          // ui: "datetimepicker"
          ui: function(element) {
            element.kendoDateTimePicker({
              format: 'dd/MM/yyyy HH:mm'
            })
          }
        }
      }]
    }
  },
  methods: {
    remakeSales() {
      this.recalculating = true
      this.axios.get('sales/distsales/remake').then(response => {
        this.recalculating = false
        this.$refs.theGrid.reload()
      })
    }
  }
}
</script>
